// import { Movie } from "@mui/icons-material";
// import { Icon } from "@mui/material";
import "./Header.css";

const Header = () => {
  return (
    <span onClick={() => window.scroll(0, 0)} className="header">
    Entertainment Hub
    </span>
  );
};

export default Header;